// extracted by mini-css-extract-plugin
export var typingIndicator = "_nb-0";